import React from 'react';
import ImageCarousel from './ImageCarousel';
import PropertyDescription from './PropertyDescription';
import { useSiteImages } from '@/hooks/useSiteImages';

const PropertySection = () => {
  const description = `Ty Gwennili, qui signifie maison des hirondelles en breton, est une magnifique maison de vacances en bord de mer qui vous ouvre ses portes pour un séjour inoubliable en Bretagne.

Disponible à la location, cette maison neuve en bois de plain-pied construite en décembre 2022, est idéalement situé à 5 minutes à pied d'une belle et grande plage de sable blanc : La Grève Blanche.`;

  const shortDescription = `Ty Gwennili, qui signifie maison des hirondelles en breton, est une magnifique maison de vacances en bord de mer qui vous ouvre ses portes pour un séjour inoubliable en Bretagne.`;

  const { images, loading } = useSiteImages('property');
  const propertyImages = images.map((img) => ({ url: img.url, alt: img.alt }));

  return (
    <div className="space-y-12">
      {!loading && propertyImages.length > 0 && <ImageCarousel images={propertyImages} />}
      <PropertyDescription
        description={description}
        shortDescription={shortDescription}
      />
    </div>
  );
};

export default PropertySection;

